/**
 * Maps the raw BO option list (from the boOptions Redux slice) to the
 * `BadgeWithIconProps` shape consumed by `<BadgeDropdown>`, and
 * pre-sorts/filters so the rendered list reference is stable.
 *
 * @module busniessOffice/components/singleComment/hooks/useBoStatusOptions
 */

import { useMemo } from "react";
import { BadgeWithIconProps } from "../../../../../../../data-model/badgeWithIconProps";
import { BOOptionModel } from "../../../../../../../data-model/boOptionModel";

/**
 * @param boOptions - Raw options from Redux (may be undefined while loading).
 * @returns Memoised badge list, sorted by id ascending and excluding empty ids.
 */
export const useBoStatusOptions = (
  boOptions: BOOptionModel[] | null | undefined,
): BadgeWithIconProps[] => {
  return useMemo(() => {
    if (!boOptions) return [];
    return boOptions
      .map((option) => ({
        id: option.value,
        text: option.label,
        bgColor: "#F5F5F5",
        textColor: "#0F0F0F",
      }))
      .filter((status) => status.id !== "")
      .sort((a, b) => a.id.localeCompare(b.id));
  }, [boOptions]);
};
